var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"profile-page-view"},[_c('div',{staticClass:"scroll-wrapper"},[_c('MyContent')],1),_c('AllNav')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }